import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { safeFormat } from 'utils/dateUtils';
import buildSearchLink from 'utils/search/buildSearchLink';
import { TrackingClient } from '@sparefoot/tracking-client';
import { setLocation } from '@sparefoot/react-core/utils/dom';

export default function useSearchHandler({
	searchType,
	additionalSearchParams,
	type,
	location: locationLabel,
} = {}) {
	const navigate = useNavigate();

	const handleSearch = useCallback(
		({ locationParams, date }) => {
			let params = {
				...locationParams,
			};

			if (searchType) {
				params.type = searchType;
			}

			if (date) {
				params.moveInDate = safeFormat(date, 'MM/dd/yyyy');
			}

			if (additionalSearchParams) {
				params = { ...params, ...additionalSearchParams };
			}

			const searchUrl = buildSearchLink(params, true);
			TrackingClient.trackSearchSubmitted({
				search_filters: type || 'storage',
				search_label: locationLabel,
				search_term: params.location,
			});

			try {
				navigate(searchUrl);
			} catch {
				setLocation(searchUrl);
			}
		},
		[searchType, additionalSearchParams, type, locationLabel, navigate],
	);

	return handleSearch;
}
